import t from "react";
import { CustomizationContext as o } from "./context.js";
function i() {
  return t.useContext(o);
}
export {
  i as default
};
//# sourceMappingURL=useCustomization.js.map
